"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const Spinner = ({ getStyles, cx }) => (react_1.default.createElement("div", { className: cx("spinner", (0, css_1.css)(getStyles("spinner"))) },
    react_1.default.createElement("svg", { viewBox: "25 25 50 50" },
        react_1.default.createElement("circle", { cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: "2", strokeMiterlimit: "10" }))));
Spinner.propTypes = {
    getStyles: prop_types_1.default.func.isRequired,
    cx: prop_types_1.default.func.isRequired,
};
exports.default = Spinner;
//# sourceMappingURL=Spinner.js.map